import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { reactivateLenderServicer, clearMessages } from '../actions/reactivationActions'
import LgyAlertDialog from '../../../components/util/lgy-alert-dialog/LgyAlertDialog'
import LgyInputField from '../../../components/util/lgy-input-field/LgyInputField'
import { required } from '../../../utils/validations'
import LgyLink from 'app/components/util/lgy-link/LgyLink'

const handleSubmit = ({ id, pin }, dispatch, props) => {
  let type = props.user.affiliations.some(aff => aff.name === 'LENDER') ? 'LENDER' : 'SERVICER'
  dispatch(reactivateLenderServicer({ type, id, pin }))
}

const ReactivationForm = ({ pristine, handleSubmit, reset, user, submitState, dispatch }) =>
  <div className='reactivation-form'>
    <LgyAlertDialog type={submitState.error ? 'error' : 'warning'} heading='Inactive Account' paragraph>
      {submitState.error ?
        <p>{submitState.message}</p> :
        <p>
          {(user.entities.some(ent => ent.name === 'LenderAdminUser') || user.entities.some(ent => ent.name === 'ServicerAdminUser')) && user.affiliations.some(aff => aff.name === 'LENDER' || aff.name === 'SERVICER') ?
            `You did not validate your account by the 90 day mark and your account has expired.
          If you still work with the company you were an admin for and you are requesting reactivation please enter your ID and PIN and click Submit to continue.  
          If your employer has been changed please enter the new employer's ID and PIN.`
            : `Your account has been inactivated due to a validation change.
          Please enter your current affiliate ID and PIN to get reactivated.
          If your employer has been changed please enter the new employer's ID and PIN.
          Contact your company admin for more information.`}
        </p>
      }
      <p>
        {!user.fetching && submitState.success && (user.accountStatus !== 1 || !user.active)
          && (user.entities.some(ent => ent.name === 'LenderAdminUser') || user.entities.some(ent => ent.name === 'ServicerAdminUser'))
          && <LgyAlertDialog type='error' heading='Unable to self-reactivate' text='Your account was not able to be self-reactivated. Please contact another company admin.' />
        }

      </p>
      <LgyLink className='back-button' to='/lgyhub/profile/affiliation' >
        <button className="usa-button-secondary">
          Click here if you have changed affiliate type
        </button>
      </LgyLink>
      <form autoComplete='off' className='usa-form' onSubmit={handleSubmit}>
        <fieldset className='reactivation-form-fields'>
          <legend className='usa-sr-only'>Reactivate Lender/Servicer Account</legend>
          <Field
            name='id'
            id='id'
            component={LgyInputField}
            label={user.affiliations.some(aff => aff.name === 'LENDER') ? 'Lender ID:' : 'Servicer ID:'}
            type='text'
            placeholder='ID'
            maxLength='10'
            validate={required}
            normalize={value => value.replace(/(\D)*/g, '')}
            autoFocus
            required />
          <Field
            name='pin'
            id='pin'
            component={LgyInputField}
            label={user.affiliations.some(aff => aff.name === 'LENDER') ? 'Lender PIN:' : 'Servicer PIN:'}
            type='text'
            placeholder='PIN'
            maxLength='8'
            validate={required}
            normalize={value => value.replace(/(\W)*/g, '')}
            required />
          <div className='reactivation-form-buttons'>
            <button type='submit' disabled={submitState.posting}>{submitState.posting ? 'Submitting...' : 'Submit'}</button>
            <button type='button' disabled={submitState.posting || pristine} onClick={() => { reset(); dispatch(clearMessages()) }}>Reset Form</button>
          </div>
        </fieldset>
      </form>
    </LgyAlertDialog>
  </div>

export default reduxForm({ form: 'reactivationForm', onSubmit: handleSubmit })(ReactivationForm)
